export default __webpack_public_path__ + "static/media/breastfeeding.d8780fba.png";